
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { RoleManagementService } from '@services/role.management.service';
import { TestService } from '@services/test.service';
import { Subject, Subscription } from 'rxjs';
import { filter, switchMap, takeUntil } from 'rxjs/operators';
import { TestsCreateComponent } from '../tests-create/tests-create.component';
import { WebErrorService } from '@services/webError.service';
import { ScoringTypeEnum, ScoringTypeName1, ScoringTypeNameEnum } from 'src/app/shared/config/questions.config';
import { TranslateService } from '@ngx-translate/core';
import { DelMessageComponent } from 'src/app/shared/del-message/del-message.component';
import { NotificationService } from '@services/notification.service';
import { videoAssetGroups } from '@configs/videoTitles';
@Component({
  selector: 'app-tests-landing',
  templateUrl: './tests-landing.component.html',
  styleUrls: ['./tests-landing.component.scss']
})
export class TestsLandingComponent implements OnDestroy {
  testServiceSubscription$: Subscription | undefined;
  testFilterServiceSubscription$: Subscription | undefined;
  tests: any;
  displayedColumns: string[] = ['itemBankName',
    'itemCount',
    'duration',
    'Scoringtype',
    'itemStatus',
    'updated',
    'tags',
    'action'
  ];
  totalRecords: any;
  searchText: any;
  page: number = 1;
  itemName = '';
  testName = '';
  itemDescription = '';
  testDescription = '';
  itemTag = '';
  itemStatus = '';
  testStatus = '';
  isItemDescended = true;
  public config: any = {
    id: 'custom',
    itemsPerPage: 3,
    currentPage: 1
  };
  isNoTest = true;

  pageOfItems: any;
  noDataFound = false;
  testStatusList: any;
  globalcollectionuuid: any;
  testId: any;
  routeSubscription: Subscription;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) set content(paginator: MatPaginator) {
    this.tests.paginator = paginator;
  }
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  ScoringTypeNameEnum = ScoringTypeNameEnum;
  ScoringTypeName1 = ScoringTypeName1;
  private unsubscribe: Subject<void> = new Subject<void>();
  langCode : string;
  showPaginator: boolean = false;
  currentUserData: any;
  isHidden = false;
  videoLinks: any;
  videoAssetGroups = videoAssetGroups;
  hoverVideoApiCall: boolean = false;
  constructor(private testService: TestService, private router: Router,
    private routerstate: ActivatedRoute, public dialog: MatDialog,
    private webErrorService: WebErrorService,
    public roleSer: RoleManagementService,
    public translate: TranslateService,
    public notificationService: NotificationService) {
      this.currentUserData = JSON.parse(sessionStorage.currentUser);
    this.routeSubscription = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(url => { this.getTestStatusListData(); this.routeSubscription.unsubscribe(); });
    this.langCode = localStorage.getItem('language');
  }

  onTrainingIcon(groupName) {
    this.isHidden = true;
    if (!this.hoverVideoApiCall) {
      this.testService.videoTutorial(groupName).subscribe(video => {
        this.videoLinks = video.data;
        this.hoverVideoApiCall = true;
      });
    }
  }

  open_in_new_window(features, link) {
    var new_window;
    if(features !== undefined && features !== '') {
      new_window = window.open('', '_blank', features);
    }
    else {
      new_window = window.open('', '_blank');
    }

    let video = '<video controls controlsList="nodownload" style="width: 100%; height: 100vh;"><source src="' + link + '" type="video/mp4" /></video>'

    if(link !== null && link !== '') {
      new_window.document.write('<!doctype html><html><head><title>Video Player</title><meta charset="UTF-8" /></head><body style="padding: 0; margin: 0;" oncontextmenu="return false">' + video + '</body></html>');
    }
  }

  ngAfterViewInit(): void {
    document.onclick = (args: any) : void => {
      if(args.target.className != 'trainingIcon') {
        this.isHidden = false;
      }
    }
  }

  getTestStatusListData() {
    this.testService.getTestStatusList()?.subscribe(data => {
      this.testStatusList = data?.statuslist.slice(0, 2);
      this.testService.testStatusList.next(this.testStatusList);
    },
    (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });

    this.testService.getNewtest.subscribe(testData => {
      this.tests = testData?.data;
      if (this.tests?.length >= 1) {
        this.isNoTest = false;
      } else {
        this.tests = new MatTableDataSource(this.tests);
        this.setPaginator();
        this.isNoTest = true;

      }
    }, (error) => { }, () => { }) || undefined;
    this.routerstate.parent.paramMap.pipe(switchMap((params: any) => {
      this.globalcollectionuuid = params.get('id');
      return this.testService.getTests(this.globalcollectionuuid);
    })).subscribe(
      (testData) => {
        this.tests = testData?.data;
        if (this.tests?.length == 0) {
          this.isNoTest = true;
        }
        else {
          this.tests = new MatTableDataSource(this.tests);
          this.setPaginator();
          this.isNoTest = false;
        }
      },
      (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });
  }

  testFilter(): void {
    const filterObj = {
      collectionuuId: this.globalcollectionuuid,
      testName: encodeURIComponent(this.testName),
      testDescription: encodeURIComponent(this.testDescription),
      tag: encodeURIComponent(this.itemTag),
      testStatus: encodeURIComponent(this.testStatus)
    };

    this.testFilterServiceSubscription$ = this.testService.getTestFilter(filterObj)?.subscribe(
      (filterData) => {
        this.tests = filterData?.data;
        if (this.tests.length === 0) {
          this.noDataFound = true;
        }
        this.tests = new MatTableDataSource(this.tests);
        this.setPaginator();
      },
      (error) => {
        this.isNoTest = true;
        this.webErrorService.handleAPIErrors(error);
      },
      () => {
      }) || undefined;
    this.noDataFound = false;
  }

  setPaginator(): void {
    setTimeout(() => {
      this.tests.paginator = this.paginator;
      this.tests.sort = this.sort;

      // ------Set translation for pagination------
      if(this.tests.paginator) {
        this.showPaginator = true;
        this.translate.stream([
          'test.pagination.pageLabel',
          'test.pagination.firstPage',
          'test.pagination.lastPage',
          'test.pagination.nextPage',
          'test.pagination.prevPage'
        ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
            this.tests.paginator._intl.itemsPerPageLabel = translation['test.pagination.pageLabel'];
            this.tests.paginator._intl.firstPageLabel = translation['test.pagination.firstPage'];
            this.tests.paginator._intl.lastPageLabel = translation['test.pagination.lastPage'];
            this.tests.paginator._intl.nextPageLabel = translation['test.pagination.nextPage'];
            this.tests.paginator._intl.previousPageLabel = translation['test.pagination.prevPage'];

            this.tests.paginator._intl.changes.next();
        });
      }
    });
  }

  onChangePage(pageOfItems: Array<any>) {
    this.totalRecords = this.tests.length;
  }

  dateSort(): void {
    this.isItemDescended = !this.isItemDescended;
    this.tests.sort(this.sortdate);
  }

  sortdate(a: any, b: any) {
    return b.updated > a.updated;
  }

  resetFilter() {

    this.testName = '';
    this.testDescription = '';
    this.itemTag = '';
    this.testStatus = '';
    this.noDataFound = false;
    this.testServiceSubscription$ = this.testService.getTests(this.globalcollectionuuid)?.subscribe(
      (resetData) => {
        this.tests = resetData?.data;
        if (this.tests.length === 0) {
          this.noDataFound = true;
        }
        this.tests = new MatTableDataSource(this.tests);
        this.setPaginator();
      },
      (error) => {
        this.router.navigate(["/login"]);
        this.webErrorService.handleAPIErrors(error);
      },
      () => {
      }) || undefined;
  }

  navigateToItemDetails(id: any, testId: any, scoringTypeId: any) {
    sessionStorage.setItem('testBankId', testId);
    sessionStorage.setItem('testScoringTypeId', scoringTypeId);
    this.router.navigate(["../tests", id], { relativeTo: this.routerstate });
  }

  createNewTest() {
    if(this.roleSer.accessData && this.roleSer.accessData.insertAllowed || this.roleSer.accessData.updateAllowed){
      const dialogConfig: MatDialogConfig<TestsCreateComponent> = {
        minWidth: '650px',
      };
      const dialogRef = this.dialog.open(TestsCreateComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
        this.resetFilter();
      });
    }
  }

  ngOnDestroy() {
    if (this.testServiceSubscription$) {
      this.testServiceSubscription$.unsubscribe();
    }
    if (this.testFilterServiceSubscription$) {
      this.testFilterServiceSubscription$.unsubscribe();
    }

    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  deleteItem(row) {
    const dialogRef = this.dialog.open(DelMessageComponent, {
      data: {
        message: this.translate.instant('test.deletePopup.message'),
        buttonText: {
          ok: this.translate.instant('test.deletePopup.btnYes'),
          cancel: this.translate.instant('test.deletePopup.btnNo')
        } } });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.testService.deleteTest(row.testuuId).subscribe((test: any) => {
          if (test.success) {
            this.notificationService.success(test.message);
            this.getTestStatusListData();
          }
        }, (error) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        });
      }
    });
  }
}
